import { createContext } from 'react';
import {
  Project,
  ProjectFinancialsApiData,
  ProjectFinancialsFieldNames,
} from 'api/project';
import {
  ProjectFinancialsComponentZoomLevelMap,
  ProjectFinancialsVisibilityConfig,
} from 'components/organisms/projects/project-financials/types';
import { GranularPermissions } from 'hooks/use-has-access';

export interface ProjectFinancialsContextProps {
  currencyCode: string; // picking from currency throws error
  project: Project;
  projectFinancials: ProjectFinancialsApiData;
  projectFinancialsVisibilityConfig: ProjectFinancialsVisibilityConfig;
  allowedZoomLevels: ProjectFinancialsComponentZoomLevelMap;
  permissionsMap: {
    [key in Extract<
      'projectProfitability',
      ProjectFinancialsFieldNames
    >]: GranularPermissions;
  };
  revenueLabels: string[];
  timeLabels: string[];
  percentageLabels: string[];
}

export const ProjectFinancialsContext =
  createContext<ProjectFinancialsContextProps>(
    {} as ProjectFinancialsContextProps, // TODO: Ensure that provider sets values properly
  );
